import React from 'react';
import { arrayOf, func, shape, string } from 'prop-types';

import DesktopBreadcrumb from 'components/DesktopBreadcrumb';
import MobileBreadcrumb from 'components/MobileBreadcrumb';
import useGetCurrentDevice from 'hooks/useGetCurrentDevice';

const BreadcrumbSwitch = ({ pathList, onClick, ...props }) => {
  const { isMobile } = useGetCurrentDevice();

  if (isMobile)
    return (
      <MobileBreadcrumb
        path={pathList[pathList.length - 1]}
        {...props}
        onClick={onClick}
      />
    );

  return <DesktopBreadcrumb pathList={pathList} {...props} onClick={onClick} />;
};

BreadcrumbSwitch.propTypes = {
  pathList: arrayOf(
    shape({
      label: string,
      link: string,
    }),
  ).isRequired,
  onClick: func,
  className: string,
};

BreadcrumbSwitch.defaultProps = {
  className: '',
  onClick: null,
};

export default BreadcrumbSwitch;
